var _circle, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.8398,
    r: 22,
    fill: "#0A7CC1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_60_159",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 11,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11.4199,
    width: 23.3666,
    height: 23.3666,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_60_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9906 30.892V31.4189L12.8553 18.1933C12.8553 18.1932 12.8554 18.193 12.8556 18.1928C12.8562 18.1918 12.8591 18.1877 12.8662 18.1806C12.8733 18.1735 12.8775 18.1706 12.8785 18.1699C12.8794 18.1693 12.8792 18.1695 12.8787 18.1697C12.8783 18.1699 12.8802 18.169 12.8858 18.168C12.8917 18.1669 12.9029 18.1654 12.9208 18.1654C12.9387 18.1654 12.95 18.1669 12.9558 18.168C12.9614 18.169 12.9633 18.1699 12.9629 18.1697C12.9624 18.1695 12.9623 18.1693 12.9631 18.1699C12.9641 18.1706 12.9683 18.1735 12.9754 18.1806C12.9825 18.1877 12.9854 18.1918 12.986 18.1928C12.9866 18.1937 12.9865 18.1935 12.9863 18.1931C12.9861 18.1926 12.987 18.1946 12.988 18.2002C12.9891 18.206 12.9906 18.2173 12.9906 18.2352V30.892ZM13.8944 31.9354C13.6938 31.9354 13.5234 31.8916 13.3676 31.7959H13.8944H26.5513C26.5692 31.7959 26.5804 31.7974 26.5863 31.7985C26.5919 31.7995 26.5938 31.8004 26.5934 31.8002C26.5929 31.8 26.5927 31.7998 26.5936 31.8004C26.5946 31.8011 26.5988 31.804 26.6059 31.8111C26.613 31.8182 26.6159 31.8223 26.6165 31.8233C26.6171 31.8242 26.617 31.824 26.6168 31.8236C26.6167 31.8233 26.6169 31.8237 26.6172 31.825C26.6175 31.8262 26.618 31.828 26.6185 31.8307C26.6196 31.8365 26.6211 31.8478 26.6211 31.8657C26.6211 31.8836 26.6196 31.8948 26.6185 31.9006C26.6181 31.9027 26.6178 31.9043 26.6175 31.9054C26.617 31.9074 26.6166 31.908 26.6168 31.9078C26.617 31.9073 26.6171 31.9071 26.6165 31.908C26.6159 31.909 26.613 31.9131 26.6059 31.9202C26.6041 31.922 26.6025 31.9236 26.6011 31.9248C26.5969 31.9286 26.5944 31.9304 26.5936 31.9309C26.5927 31.9315 26.5929 31.9313 26.5934 31.9311C26.5936 31.931 26.5934 31.9311 26.5927 31.9313C26.5917 31.9316 26.5897 31.9322 26.5863 31.9328C26.5804 31.9339 26.5692 31.9354 26.5513 31.9354H13.8944ZM17.7888 28.041C17.495 28.041 17.2659 27.9469 17.0527 27.7337C16.8396 27.5205 16.7455 27.2915 16.7455 26.9976V15.3143C16.7455 15.0205 16.8396 14.7914 17.0527 14.5782C17.2659 14.3651 17.495 14.271 17.7888 14.271H29.4721C29.766 14.271 29.9951 14.3651 30.2082 14.5782C30.4214 14.7914 30.5155 15.0205 30.5155 15.3143V26.9976C30.5155 27.2915 30.4214 27.5205 30.2082 27.7337C29.9951 27.9469 29.766 28.041 29.4721 28.041H17.7888Z",
    fill: "url(#paint0_linear_60_159)",
    stroke: "url(#paint1_linear_60_159)",
    strokeWidth: 1.80769
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.6394V18.2004C20 17.9663 20.0854 17.7776 20.2561 17.6346C20.4268 17.4915 20.626 17.4199 20.8537 17.4199C20.9248 17.4199 21.003 17.4264 21.0884 17.4394C21.1738 17.4524 21.252 17.485 21.3232 17.537L26.6159 20.776C26.7439 20.8541 26.8399 20.9484 26.904 21.0589C26.968 21.1695 27 21.2898 27 21.4199C27 21.55 26.968 21.6703 26.904 21.7809C26.8399 21.8915 26.7439 21.9858 26.6159 22.0638L21.3232 25.3028C21.252 25.3549 21.1738 25.3874 21.0884 25.4004C21.003 25.4134 20.9248 25.4199 20.8537 25.4199C20.626 25.4199 20.4268 25.3484 20.2561 25.2053C20.0854 25.0622 20 24.8736 20 24.6394Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_159",
    x1: 13.0465,
    y1: 31.7399,
    x2: 30.32,
    y2: 14.4664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_159",
    x1: 13.3217,
    y1: 14.8986,
    x2: 29.5986,
    y2: 32.3023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.116d47cc338f3e68bfdae5c645e7e179.svg";
export { ForwardRef as ReactComponent };